import { memo } from "react";
import { generatePath, Link, useParams } from "react-router";

import { PATHS } from "@/routes/paths";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { Button } from "@/components/ui/button/button";
import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useRoomMaxRoomNum } from "./hooks";
import { QuestionSectionWrapper } from "../../../../../../../../_shared/ui/components/system/question/_layouts/item-wrapper";

export const QuestionDummyRoomMaxRoomNum = memo(() => {
	const { hotelID } = useParams<{ hotelID: string }>();
	const roomStockPath = generatePath(PATHS.HOTEL.ITEMS.ROOM.STOCK, { hotelID: hotelID! });

	const { maxRoomNum, onSetMaxRoomNum, isEdited, hasError } = useRoomMaxRoomNum();

	return (
		<FeatureIslandCategoryQuestionForMain
			required
			isEdited={isEdited}
			hasError={hasError}
			title={"提供できる部屋の数"}
			guide="1日に提供可能な最大の在庫数を設定してください。"
			inputChildren={
				<div className="space-y-6">
					<div>
						<p className="text-sm text-error-600">
							※ 日ごとの在庫を
							<Button variant="link-blue" asChild className="p-0">
								<Link
									to={roomStockPath}
									className="mx-1 font-bold underline-offset-4 hover:underline"
									viewTransition
									target="_blank"
								>
									在庫管理画面
								</Link>
							</Button>
							で設定している場合はそちらが優先されますのでご注意ください。
						</p>
					</div>
					<QuestionSectionWrapper>
						<InputNumberField
							handleInput={onSetMaxRoomNum}
							value={maxRoomNum.value}
							errorMessage={maxRoomNum.error}
							hiddenSpinButton={false}
						/>
						<p>部屋を提供可能</p>
					</QuestionSectionWrapper>
				</div>
			}
		/>
	);
});

QuestionDummyRoomMaxRoomNum.displayName = "QuestionDummyRoomMaxRoomNum";
